// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app-content-trashbin tbody tr[data-type=\"file\"] td a.name,#app-content-trashbin tbody tr[data-type=\"file\"] td a.name span.nametext,#app-content-trashbin tbody tr[data-type=\"file\"] td a.name span.nametext span{cursor:default}#app-content-trashbin .summary :last-child{padding:0}#app-content-trashbin #filestable .summary .filesize{display:none}\n", ""]);
// Exports
module.exports = exports;
